import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "twitter",
  "use": "twitter-usage",
  "viewBox": "0 0 630 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 630 512\" id=\"twitter\"><style>#twitter .st0{fill:none}</style><path class=\"st0\" d=\"M115 56h400v400H115z\" /><path d=\"M198.1 512c237.7 0 367.8-197 367.8-367.8 0-5.6-.1-11.2-.4-16.7 25.2-18.2 47.2-41 64.5-66.9-23.2 10.3-48.1 17.2-74.2 20.3 26.7-16 47.2-41.3 56.8-71.5-25 14.8-52.6 25.6-82.1 31.4C506.9 15.7 473.4 0 436.2 0c-71.4 0-129.3 57.9-129.3 129.2 0 10.1 1.1 20 3.4 29.5-107.4-5.4-202.7-56.8-266.4-135C32.7 42.8 26.3 65 26.3 88.6c0 44.8 22.8 84.4 57.5 107.6-21.2-.7-41.1-6.5-58.5-16.2v1.6c0 62.6 44.6 114.9 103.7 126.7-10.9 3-22.3 4.5-34.1 4.5-8.3 0-16.4-.8-24.3-2.3 16.5 51.4 64.2 88.7 120.7 89.8-44.2 34.7-100 55.3-160.5 55.3-10.4 0-20.7-.6-30.8-1.8C57.2 490.6 125.1 512 198.1 512\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./sv_cms/static/assets/images/icons/twitter.svg
// module id = 281
// module chunks = 6